import React from "react";
import { Navigate } from "react-router-dom";

const RoleRoute = ({ children, allowedRoles }) => {
  const isAuthenticated = !!localStorage.getItem("token");
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  const role = localStorage.getItem("user_role") || "";
  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
    return children;
  }

  return allowedRoles.includes(role) ? children : <Navigate to="/" />;
};

export default RoleRoute;
